import React from "react";
//#region types
import { CommentBoxProps } from "models/propTypes/commentsPropTypes";
//#endregion
//#region components
import CommentBoxLarge from "./commentBoxLarge";
import { Grid, Skeleton } from "@mui/material";
import lazyWithReload from "utils/lazyWithReload";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const BannerImageLazy = lazyWithReload(() => import("./_partials/bannerImage"));

const BannerWithCommentBox: React.FC<CommentBoxProps> = (props) => {
  return (
    <Grid container className={cssExports.bannerWithCommentBox}>
      <Grid container item className={cssExports.bannerWithCommentBoxInner}>
        <React.Suspense fallback={<Skeleton width={362} style={{ background: "transparent" }}></Skeleton>}>
          <BannerImageLazy />
        </React.Suspense>
        <Grid item className={cssExports.commentBoxContainer}>
          <CommentBoxLarge
            commentBoxTitle={props.commentBoxTitle}
            commentBoxDescription={props.commentBoxDescription}
            actions={props.actions}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BannerWithCommentBox;
